<script>
import { containFill } from './util';
import { tick } from 'svelte';

const items = [
  {
    x: -540, y: 150,
    img: ['2020-1.png', '2020-2.png'],
    title: '2020 iWeek Winner',
    subtitle: 'BUDLIGHT PLATINUM SELTZER',
    desc: 'Bud Light Platinum Seltzer delivers a higher ABV seltzer made with agave, leveraging dark packaging designed to break through the lower ABV seltzer category that’s marked by consistent liquid bases and packaging. Whereas core seltzers were designed for daytime and outdoor occasions, Bud Light Platinum Seltzer has a right to play in higher energy, evening occasions with higher ABV and bold fruit flavors.',
    bottom: [
      {title: '45K BBLs in 2020', sub: 'STR 8/31/20, 93K BBLS sold 2021'},
      {title: 'Growing Seltzers', sub: 'Total US MULC growing (1% FY ’21 vs .29% FY ’20)'},
      {title: '6 Months to Market', sub: '2020 STR 8/31 after winning iWeek earlier same year'}
    ]
  },
  {
    x: 40, y: 150,
    img: ['2021-1.png', '2021-2.png'],
    title: '2021 iWeek Winner',
    subtitle: 'BOXOLOGY',
    desc: 'Boxology delivers quality cocktails made easy in the first ever bag-in-box variety pack. With each box, we deliver two perfectly paired cocktails (10 servings each flavor) with no bottles, mixers, or mess. The Apollo team has built incredibly strong distribution in large format grocery and small format liquor/convenience stores which gives us a right to win in the multi-serve RTD space, where we are already seeing very strong sales performance. With this strong performance, Boxology has been approved to move from Apollo to LaunchPad!',
    bottom: [
      {title: 'ROS: 2.5 Units', sub: 'Sustaining above RTD benchmark'},
      {title: '33% Reorders', sub: 'Exceeding Beyond Beer benchmark'},
      {title: '8 Months to Market', sub: '2020 STR 8/31 after winning iWeek earlier same year'}
    ]
  },
  {
    x: 580, y: 150,
    img: ['2022-1.png'],
    title: '2022 iWeek Winner',
    subtitle: 'COMING SOON!',
    desc: 'Tune in for our Shark Tank Panel on Friday 18th February from 4pm ET to find out who is our 2022 Winner. ',
    bottom: []
  }
];

let modal;
let modalPictureIndex = 0;

let width = 0;
let height = 0;
let scale = 1;
const imageSize = {width: 1920, height: 1080};
$: if (width > 0 && height > 0) scale = containFill(imageSize.width, imageSize.height, width, height);

let sy = 0;
async function mobileSelect(item) {
  sy = window.scrollY;
  modal = item;
  await tick();
  window.scrollTo(0, 0);
}

async function closeModal() {
  modal = undefined;
  modalPictureIndex = 0;
  await tick();
  window.scrollTo(0, sy);
}
</script>

{#if modal}
  <div class="modal hidemobile">
    <div class="modal-content col">
      
      <div class="row between vcenter" style="margin-bottom: 24px">
        <div class="modal-title">{modal.title}</div>
        <div class="modal-close material-button" on:click={closeModal}>
          <span class="material-icons"> cancel </span>
        </div>
      </div>

      <div class="row">
        <div class="pictures">
          {#each modal.img as img, i}
            <img class="modal-picture" src="/img/{img}" class:show={modalPictureIndex === i} />
          {/each}
          
          {#if modal.img.length > 1}
          <div class="right centercenter" on:click={() => modalPictureIndex = (modalPictureIndex + 1) % modal.img.length}>
            <span class="material-icons"> chevron_right </span>
          </div>

          <div class="left centercenter" on:click={() => modalPictureIndex = (modalPictureIndex - 1) % modal.img.length}>
            <span class="material-icons">chevron_left</span>
          </div>
          {/if}
        </div>

        <div class="col">
          <div class="title mb-16">{modal.subtitle}</div>
          <div class="desc mb-32">{modal.desc}</div>
          <div class="row" style="gap: 8px">
            {#each modal.bottom as bottom}
              <div class="col">
                <div class="coltitle mb-8">{bottom.title}</div>
                <div class="colsub">{bottom.sub}</div>
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile -->
  <div class="card card-modal col">
    <div class="modal-close material-button" on:click={closeModal}>
      <span class="material-icons">cancel</span>
    </div>

    <div class="pictures">
      {#each modal.img as img, i}
        <img class="modal-picture" src="/img/{img}" class:show={modalPictureIndex === i} />
      {/each}

      {#if modal.img.length > 1}
        <div class="right centercenter" on:click={() => modalPictureIndex = (modalPictureIndex + 1) % modal.img.length}>
          <span class="material-icons"> chevron_right </span>
        </div>

        <div class="left centercenter" on:click={() => modalPictureIndex = (modalPictureIndex - 1) % modal.img.length}>
          <span class="material-icons">chevron_left</span>
        </div>
      {/if}
    </div>
    <div style="padding: 16px">
      <div class="card-title mb-16">{modal.title}</div>
      <div class="card-subtitle">{modal.subtitle}</div>
      <div class="card-desc mb-16">{modal.desc}</div>
      {#each modal.bottom as bottom}
        <div class="card-coltitle">{bottom.title}</div>
        <div class="card-colsub mb-16">{bottom.sub}</div>
      {/each}
    </div>
  </div>
{/if}

{#if !modal}
  <div class="section-header">WINNERS ARCHIVE</div>
{/if}

<div class="container" bind:clientWidth={width} bind:clientHeight={height}>
  <div class="content background-image" />

  <div class="center">
    {#each items as item}
      <div class="entera" style="top: {scale * item.y}px;left: {scale * item.x}px" on:click={() => modal = item}>ENTER THE ARCHIVE</div>
    {/each}
  </div>
</div>

{#if !modal}
  <div class="mobile-container col">
    {#each items as item}
      <div class="card col" on:click={() => mobileSelect(item)}>
        <div class="card-img mb-16" style="background-image: url(/img/{item.img[0]})" />
        <div style="padding: 16px">
          <div class="card-title mb-16">{item.title}</div>
          <div class="card-subtitle mb-16">{item.subtitle}</div>
          <div class="enter mb-16">ENTER THE ARCHIVE</div>
        </div>
      </div>
    {/each}
  </div>
{/if}

<style lang="scss">
@import './util';
@import './theme';

.left, .right {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border: 2px solid white;
  border-radius: 999px;
  color: white;
  background-color: black;
  cursor: pointer;
  user-select: none;
  outline: none;
  -webkit-tap-highlight-color:transparent;
}

.left {
  left: 0%;
}
.right {
  right: 0%;
}

.hidemobile {
  @include mobile {
    display: none;
  }
}

.container {
  width: 100%;
  @include aspect-ratio(1920, 1080);

  @include mobile {
    display: none;
  }
}

.mobile-container {
  gap: 16px;
  max-width: 100%;
  display: none;
  @include mobile {
    display: flex;
  }
}

.background-image {
  background-image: url('/img/winners.jpg');
  background-size: cover;
}

.card-modal {
  display: none;
  @include mobile {
    display: flex;
  }
}

.card {
  position: relative;
  @include shadow;
  border-radius: 5px;
  overflow: hidden;
  background-color: white;
}

.card-img {
  height: 240px;
  background-size: cover;
}

.card-title {
  font-weight: 900;
  font-size: 20px;
}

.card-subtitle {
  font-weight: 900;
  font-size: 16px;
}

.card-desc {
  font-weight: 300;
  font-size: 14px;
}

.card-coltitle {
  font-weight: 900;
  font-size: 16px;
}

.card-colsub {
  font-weight: 300;
  font-size: 14px;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
}

.enter, .entera {
  background-color: black;
  padding: 4px 12px;
  color: $primary-color;
  user-select: none;
  cursor: pointer;
  font-weight: 900;
  font-size: 16px;
  white-space: nowrap;
}

.entera {
  transform: translateX(-50%);
  position: absolute;
}

.modal-title {
  font-weight: 900;
  font-size: 40px;
}

.title {
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
}

.desc {
  font-weight: 300;
  font-size: 16px;
}

.coltitle {
  font-weight: 900;
  font-size: 24px;
  text-align: center;
}

.colsub {
  font-weight: 900;
  font-size: 16px;
  text-align: center;
}


.center {
  position: absolute;
  top: 50%;
  left: 50%;
}

.modal-content {
  background-image: url('/img/modal-background.jpg');
  background-size: cover;
  position: relative;
  width: 90%;
  max-height: 100vh;
  padding: 64px;
  color: white;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 1000px;
  
  @include landscape {
    width: 100%;
    padding: 32px;
  }
}

.button-back {
  position: absolute;
  width: 19px;
  height: 19px;
  top: 21px;
  left: 20px;
  @include shadow;
  border-radius: 9999px;
  background-color: black;
}

.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;
}

.picture {
  @include aspect-ratio(1, 1);
  margin: 8px;
  // border-bottom: 1px solid #c1ac7e;
}

.pictures {
  position: relative;
  width: 320px;
  height: 320px;
  min-width: 320px;
  margin-right: 48px;

  @include mobile {
    margin-right: 0;
    align-self: center;
  }
}

.modal-picture {
  position: absolute;
  top: 0; left: 0;
  width: 320px;
  height: 320px;
  object-fit: cover;
  object-position: center top;
  visibility: hidden;
}

.show {
  visibility: visible;
}
</style>